import {CustomerRequestStatusCd} from '../';
import {EnumHelper} from './enum-helper';

export class CustomerRequestStatusCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in CustomerRequestStatusCd ) {
      this._values.push(CustomerRequestStatusCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): CustomerRequestStatusCd {

    for ( const obj in CustomerRequestStatusCd ) {
      if (CustomerRequestStatusCd[obj] === value){
        return CustomerRequestStatusCd[obj] as CustomerRequestStatusCd;
      }
    }
  }
}

const CustomerRequestStatusCdHelper = new CustomerRequestStatusCdHelperEnumHelperClass();
export default CustomerRequestStatusCdHelper;
